import { render, staticRenderFns } from "./appMenu.vue?vue&type=template&id=57210ca6&scoped=true&"
import script from "./appMenu.vue?vue&type=script&lang=js&"
export * from "./appMenu.vue?vue&type=script&lang=js&"
import style0 from "./appMenu.vue?vue&type=style&index=0&id=57210ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57210ca6",
  null
  
)

export default component.exports